import Button from '@mui/joy/Button'
import LockOpen from '@mui/icons-material/LockOpen'

export const UnlockButton = ({ onClick }) => (
    <Button
        variant="solid"
        color="neutral"
        onClick={onClick}
        startDecorator={<LockOpen />}
    >
        Unlock
    </Button>
)
